import HttpProxy from "@/services/HttpProxy";

export default class TutorialService {
  static async get(parameters) {
    const response = await HttpProxy.submit({
      method: "get",
      url: "Course/GetAll",
      parameters,
    });
    return response?.data ?? null;
  }
  static async updateView(id) {
    const response = await HttpProxy.submit({
      method: "put",
      url: `Course/View/${id}`,
      data: {},
    });
    return response?.data ?? null;
  }
}
